import React, { useEffect, useRef, useState } from "react";
import { AngleDown } from "flowbite-react-icons/outline";

const DropdownSelect = ({label, formik, name, selectedItem, fieldDefaultText, options, onChange, elementClasses,
                            maxLabelLength = null, error = false, onSearchChange = null, isLoading = false, minSearchChars = null}) => {
    const { errors, touched } = formik;
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const dropdownRef = useRef(null);
    const showError = (!errors[name] && error) || (touched[name] && errors[name]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const toggleDropdown = () => {
        setIsDropdownOpen((prevState) => !prevState);
        setSearchTerm("");
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        if (onSearchChange) {
            onSearchChange(value);
        }
    };

    // If onSearchChange is provided, don't filter client-side (let the parent handle it)
    const filteredOptions = onSearchChange
        ? options
        : options.filter(item => item.name.toLowerCase().includes(searchTerm.toLowerCase()));

    const getLabel = () => {
        if (!selectedItem)
            return fieldDefaultText;

        if(maxLabelLength)
            return (selectedItem.name.length > maxLabelLength ? selectedItem.name.slice(0, maxLabelLength) + "..." : selectedItem.name);

        return selectedItem.name;
    }

    return (
        <div ref={dropdownRef} className={elementClasses}>
            <span
                className="sl-font sl-font-medium sl-text-sm sl-text-gray-700"
                dangerouslySetInnerHTML={{ __html: label }}
            />
            <div
                onClick={toggleDropdown}
                className={`sl-flex flex-row sl-justify-between sl-items-center sl-border-radius-8 sl-bg-white sl-border-gray-300 sl-border-1
            sl-border-solid sl-shadow-xs sl-pr-16 sl-pl-16 sl-pt-10 sl-pb-10 sl-cursor-pointer 
            ${showError ? "sl-border-1 sl-border-solid sl-border-error-300 " : ""}`}
            >
                <span className="sl-text-gray-700 sl-font-medium sl-font">
                    {getLabel()}
                </span>
                <AngleDown size={20} color={"#344054"} />
            </div>
            {isDropdownOpen && (
                <div className="sl-bg-white sl-shadow-md sl-border sl-border-gray-300 sl-rounded-md sl-mt-2 sl-overflow-hidden sl-max-h-80 sl-overflow-y-hidden">
                    <div className="sl-p-2">
                        <input
                            type="text"
                            className="sl-w-full sl-p-2 sl-border sl-border-gray-300 sl-rounded"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={handleInputChange}
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>

                    <div className="sl-p-4 sl-flex sl-flex-col sl-gap-2 sl-max-h-66 sl-overflow-y-scroll">
                        {isLoading ? (
                            <div className="sl-text-gray-500 sl-p-2 sl-flex sl-items-center sl-gap-2">
                                <span>Loading...</span>
                            </div>
                        ) : minSearchChars && searchTerm.length > 0 && searchTerm.length < minSearchChars ? (
                            <div className="sl-text-gray-500 sl-p-2">
                                Type at least {minSearchChars} characters to search
                            </div>
                        ) : filteredOptions.length > 0 ? (
                            filteredOptions.map((item, index) => (
                                <div className="flex items-center gap-2" key={index}>
                                    <div
                                        className="sl-cursor-pointer sl-p-2 sl-hover:bg-gray-100 sl-rounded"
                                        id={item.id}
                                        onClick={() => {
                                            onChange(item);
                                            setIsDropdownOpen(false);
                                        }}
                                    >
                                        {item.name}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="sl-text-gray-500 sl-p-2">No results found</div>
                        )}
                    </div>
                </div>
            )}
            {touched[name] && errors[name] && (
                <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm sl-font">{errors[name]}</span>
            )}
        </div>
    );
};

export default DropdownSelect;
